import { Link, useLocation } from 'react-router';
import Button from '@/components/ui/button';
import Heading from '@/components/Heading/Heading';
import PageShell from '@/components/PageShell';
import miaLogo from '@/assets/images/mia-logo-dark.svg';
import { ArrowLeftIcon } from 'lucide-react';

function Error() {
  const { state } = useLocation();
  const {
    message = 'Something went wrong. Please try again later.',
    nextLocation,
    buttonText,
  } = state || {};

  return (
    <PageShell variant='single' className='error-screen'>
      <div className='top-container flex-1'>
        <div className='text-center'>
          <div className='flex justify-center mb-4'>
            <img src={miaLogo} alt='Mia' className='' />
          </div>
          <Heading align='center'>Oops!</Heading>
          <p className='text-center mb-4'>{message}</p>

          {nextLocation && (
            <div className='text-center mb-4'>
              {nextLocation.startsWith('https://') ? (
                <Button asChild variant='default'>
                  <a href={nextLocation} target='_blank' rel='noreferrer'>
                    {buttonText}
                  </a>
                </Button>
              ) : (
                <Button asChild>
                  <Link
                    to={nextLocation}
                    className='btn btn-primary btn-block'
                  >
                    <ArrowLeftIcon className='mr-2' />
                    {buttonText}
                  </Link>
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </PageShell>
  );
}

export default Error;
